import { MessageCircle } from "lucide-react";

export default function WhatsAppWidget() {
  const phone = "917003670034";
  const msg = encodeURIComponent("Hello JSY! I'm interested in your packaging products.");
  return (
    <a
      data-testid="whatsapp-widget"
      href={`https://wa.me/${phone}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={24} />
    </a>
  );
}
